/**
 * カタカナをひらがなに変換する処理
 * @param {String} src 変換したいカタカナの文字列
 * @return {String} ひらがなに変換された文字列
 */
export const convertToHiragana = (src: string): string => {
  return src.replace(/[\u30a1-\u30f6]/g, (match) => {
    const chr = match.charCodeAt(0) - 0x60;
    return String.fromCharCode(chr);
  });
};
